var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckcircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5913_27886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.98308 4.52446V4.90012C8.98257 5.78066 8.69745 6.63745 8.17022 7.3427C7.64299 8.04795 6.90191 8.56389 6.05751 8.81355C5.21311 9.06321 4.31062 9.03323 3.48465 8.72808C2.65868 8.42292 1.95347 7.85895 1.47422 7.12026C0.994957 6.38157 0.767321 5.50775 0.825258 4.62912C0.883194 3.75049 1.2236 2.91412 1.7957 2.24476C2.36781 1.5754 3.14096 1.1089 3.99985 0.91485C4.85874 0.720795 5.75735 0.809578 6.56166 1.16796M8.98308 1.63346L4.89974 5.72087L3.67474 4.49587",
    stroke: "#858585",
    strokeWidth: 0.98,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5913_27886"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.8,
    height: 9.8,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckcircle);
export default __webpack_public_path__ + "static/media/Check circle.5c4c0141ecf690ebae96cec345d27029.svg";
export { ForwardRef as ReactComponent };